import { useState, useCallback } from 'react';
import { useFormikContext } from 'formik';
import { validateCustomerForm } from '@/utils/validate';
import { CustomerInfoForm } from '@/components/Layout';

const getDisablePay = (customerForm: CustomerInfoForm) => {
  const errors = validateCustomerForm({
    name: customerForm.name,
    email: customerForm.email,
  });
  return Object.keys(errors).length > 0;
};

export const useDisablePay = () => {
  const { values: customerForm } = useFormikContext<CustomerInfoForm>();
  const [disablePay, setDisablePay] = useState(getDisablePay(customerForm));

  const triggerValidation = useCallback(() => {
    const disablePay = getDisablePay(customerForm);
    setDisablePay(disablePay);
    return disablePay;
  }, [customerForm]);

  return {
    disablePay,
    triggerValidation,
  };
};
